import React, { createContext, FC, useContext, useMemo, useState } from 'react';

interface StepperState {
    activeStep: boolean;
    stepsCount: number;
    steps: unknown;
    currentStep: number;
    isNextStepDisable: boolean;
}

const initialState: StepperState = {
    activeStep: true,
    stepsCount: 0,
    steps: [],
    currentStep: 0,
    isNextStepDisable: true,
};

type StepperContextType = StepperState & {
    nextStep: () => void;
    prevStep: () => void;
    setSteps: (steps: unknown[]) => void;
    enableNextStep: () => void;
    disableNextStep: () => void;
};

export const StepperProvider: FC<React.PropsWithChildren> = ({ children }) => {
    const [isNextStepDisable, setIsNextStepDisable] = useState<boolean>(true);

    const disableNextStep = () => {
        setIsNextStepDisable(true);
    };

    const enableNextStep = () => {
        setIsNextStepDisable(false);
    };

    const nextStep = () => {};

    const prevStep = () => {};

    const value = useMemo(
        () => ({
            nextStep,
            prevStep,
            currentStep: 0,
            steps: [],
            isNextStepDisable,
            disableNextStep,
            enableNextStep,
        }),
        [isNextStepDisable]
    );

    return <StepperContext.Provider value={value}>{children}</StepperContext.Provider>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StepperContext = createContext<StepperState | any>(initialState);

export const useStepperContext = () => {
    const context = useContext<StepperContextType>(StepperContext);

    if (!context) throw new Error('StepperContextProvider should be wrapped.');

    return context;
};
